import { useEffect, useRef } from 'react';

type LoadMore = { hasMore: boolean; loadingMore: boolean; onLoadMore?: () => void };

/**
 * Asks for the next page when a virtualised list renders its last loaded row: once per page, and not while a page is
 * on its way. `lastRendered` is the index of the last rendered row, undefined when the list is not virtualised.
 */
export function useLoadMoreAtEnd(
  lastRendered: number | undefined,
  count: number,
  { hasMore, loadingMore, onLoadMore }: LoadMore,
): void {
  const askedAt = useRef(0);
  useEffect(() => {
    if (!hasMore || loadingMore || lastRendered !== count - 1 || askedAt.current === count) return;
    askedAt.current = count;
    onLoadMore?.();
  });
}
